import * as userConstants from "../constants/userConstants.js";

export const userLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case userConstants.USER_REGISTER_REQUEST:
      return { loading: true };
    case userConstants.USER_REGISTER_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case userConstants.USER_REGISTER_FAIL:
      return { loading: false, error: action.payload };
    case userConstants.USER_ACTIVATION_REQUEST:
      return { loading: true };
    case userConstants.USER_ACTIVATION_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case userConstants.USER_ACTIVATION_FAIL:
      return { loading: false, error: action.payload };
    case userConstants.USER_SIGNIN_REQUEST:
      return { loading: true };
    case userConstants.USER_SIGNIN_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case userConstants.USER_SIGNIN_FAIL:
      return { loading: false, error: action.payload };
    case userConstants.USER_SIGNOUT:
      return {};
    case userConstants.USER_GOOGLE_SIGNIN_REQUEST:
      return { loading: true };
    case userConstants.USER_GOOGLE_SIGNIN_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case userConstants.USER_GOOGLE_SIGNIN_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const checkUserReducer = (state = {}, action) => {
  switch (action.type) {
    case userConstants.CHECK_USER:
      return { userInfo: action.payload };
    default:
      return state;
  }
};

export const userAccountDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case userConstants.USER_ACCOUNT_DETAILS_REQUEST:
      return { loading: true };
    case userConstants.USER_ACCOUNT_DETAILS_SUCCESS:
      return {
        loading: false,
        userAccountDetails: action.payload.data.userData,
      };
    case userConstants.USER_ACCOUNT_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case userConstants.USER_SUBSCRIPTION_DETAILS_REQUEST:
      return { loading: true };
    case userConstants.USER_SUBSCRIPTION_DETAILS_SUCCESS:
      return {
        loading: false,
        userSubscriptionDetails: action.payload.data.userData,
      };
    case userConstants.USER_SUBSCRIPTION_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case userConstants.USER_WATCHLIST_REQUEST:
      return { loading: true };
    case userConstants.USER_WATCHLIST_SUCCESS:
      return { loading: false, userWatchlist: action.payload.data.watchlist };
    case userConstants.USER_WATCHLIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const userPwdResetReducer = (state = {}, action) => {
  switch (action.type) {
    case userConstants.USER_PWD_RESET_MAIL_REQUEST:
      return { loading: true };
    case userConstants.USER_PWD_RESET_MAIL_SUCCESS:
      return { loading: false };
    case userConstants.USER_PWD_RESET_MAIL_FAIL:
      return { loading: false, error: action.payload };
    case userConstants.USER_PWD_RESET_CHECK_REQUEST:
      return { loading: true };
    case userConstants.USER_PWD_RESET_CHECK_SUCCESS:
      return { loading: false, isTokenvalid: true };
    case userConstants.USER_PWD_RESET_CHECK_FAIL:
      return { loading: false, error: action.payload, isTokenvalid: false };
    case userConstants.USER_PWD_RESET_REQUEST:
      return { loading: true };
    case userConstants.USER_PWD_RESET_SUCCESS:
      return { loading: false };
    case userConstants.USER_PWD_RESET_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const userUnsubscribeMailReducer = (state = {}, action) => {
  switch (action.type) {
    case userConstants.USER_UNSUBSCRIBE_MAIL_REQUEST:
      return { loading: true };
    case userConstants.USER_UNSUBSCRIBE_MAIL_SUCCESS:
      return { loading: false, message: action.payload.message, success: true };
    case userConstants.USER_UNSUBSCRIBE_MAIL_FAIL:
      return { loading: false, error: action.payload, success: false };
    case userConstants.USER_UNSUBSCRIBE_MAIL_SETTINGS_REQUEST:
      return { loading: true };
    case userConstants.USER_UNSUBSCRIBE_MAIL_SETTINGS_SUCCESS:
      return { loading: false, message: action.payload.message, success: true };
    case userConstants.USER_UNSUBSCRIBE_MAIL_SETTINGS_FAIL:
      return { loading: false, error: action.payload, success: false };
    case userConstants.USER_RESUBSCRIBE_MAIL_SETTINGS_REQUEST:
      return { loading: true };
    case userConstants.USER_RESUBSCRIBE_MAIL_SETTINGS_SUCCESS:
      return { loading: false, success: true };
    case userConstants.USER_RESUBSCRIBE_MAIL_SETTINGS_FAIL:
      return { loading: false, error: action.payload, success: false };
    default:
      return state;
  }
};

export const userLoggedinAndPremiumCheckReducer = (state = {}, action) => {
  switch (action.type) {
    case userConstants.USER_LOGGEDIN_REQUEST:
      return { loading: true };
    case userConstants.USER_LOGGEDIN_SUCCESS_PREMIUM_FAIL:
      return { loading: false, isLoggedIn: true, isPremium: false };
    case userConstants.USER_LOGGEDIN_SUCCESS_PREMIUM_SUCCESS:
      return { loading: false, isLoggedIn: true, isPremium: true };
    case userConstants.USER_LOGGEDIN_FAIL_PREMIUM_FAIL:
      return { loading: false, isLoggedIn: false, isPremium: false };
    case userConstants.USER_LOGGEDIN_FAIL:
      return { loading: false, error: action.payload, isLoggedIn: false, isPremium: false};
    case  userConstants.USER_PREMIUM_FAIL:
      return { loading: false, error: action.payload, isLoggedIn: true, isPremium: false};
    default:
      return state;
  }
};

export const userLocationReducer = (state = {}, action) => {
  switch(action.type) {
    case userConstants.USER_COUNTRY_REQUEST:
      return { loading: true };
    case userConstants.USER_COUNTRY_FAIL:
      return { loading: false };
    case userConstants.USER_COUNTRY_SUCCESS:
      return { loading: false, locationData: action.payload.locationData};
    default:
      return state;
  }
}
